import { useEffect, useState } from 'react';
import { Minus, Square, X, Copy } from 'lucide-react';

export function TitleBar() {
  const [maximized, setMaximized] = useState(false);
  const isElectron = typeof window !== 'undefined' && window.__platform__ === 'electron';

  useEffect(() => {
    if (!isElectron) return;
    void window.api.windowIsMaximized().then(setMaximized);
    const off = window.api.onWindowMaximizeState((m) => setMaximized(m));
    return off;
  }, [isElectron]);

  return (
    <div
      className="flex h-8 select-none items-center justify-between border-b border-border bg-background pl-3 text-xs text-muted-foreground"
      style={{ WebkitAppRegion: 'drag' } as React.CSSProperties}
    >
      <div className="flex items-center gap-2 font-medium tracking-wide">
        <img
          src={`${import.meta.env.BASE_URL}branding/gto-icon.png`}
          alt=""
          className="size-6 rounded-sm object-contain"
          draggable={false}
        />
        GTO Agentic GIS
      </div>
      {isElectron && (
        <div className="flex" style={{ WebkitAppRegion: 'no-drag' } as React.CSSProperties}>
          <button
            type="button"
            onClick={() => window.api.windowMinimize()}
            className="grid h-8 w-11 place-items-center hover:bg-accent"
            aria-label="Minimize"
          >
            <Minus className="size-3.5" />
          </button>
          <button
            type="button"
            onClick={() => window.api.windowToggleMaximize()}
            className="grid h-8 w-11 place-items-center hover:bg-accent"
            aria-label={maximized ? 'Restore' : 'Maximize'}
          >
            {maximized ? <Copy className="size-3.5" /> : <Square className="size-3" />}
          </button>
          <button
            type="button"
            onClick={() => window.api.windowClose()}
            className="grid h-8 w-11 place-items-center hover:bg-destructive hover:text-destructive-foreground"
            aria-label="Close"
          >
            <X className="size-3.5" />
          </button>
        </div>
      )}
    </div>
  );
}
